import React from 'react'
import styled from 'styled-components'
import { Heading, Carousel, LineItem, LineItemPlaceholder } from '../Common'
import { ProductsCarouselProps } from './productsCarousel.props'
import {
  useConfigState,
  useProductCarouselResult,
} from '@sentecacommerce-theme/lib'

const placeholderItems: any = Array(24)
  .fill(null)
  .map((_, i) => ({
    id: i,
    isPlaceholder: true,
  }))

export const ProductsCarousel = ({
  heading,
  query,
  viewAllLink,
}: ProductsCarouselProps) => {
  const { customFieldKeys } = useConfigState()

  const filterOutOfStock = 'integer_field.inventory-hippoland-online;range;1,*'
  const filterOnlyInPhysicalStores = `boolean_field.${customFieldKeys.isOnlyInPhysicalStores};eq;false`

  const { data, isLoading } = useProductCarouselResult({
    ...query,
    filter: `${query.filter}&${filterOutOfStock}&${filterOnlyInPhysicalStores}`,
  })

  return (
    <Container>
      {!!heading && <Heading data={heading} viewAllLink={viewAllLink} />}
      {!isLoading && (
        <CarouselContainer>
          <Carousel
            slides={data?.items || placeholderItems}
            renderSlide={(item: any) => (
              <SlideContainer>
                {item.isPlaceholder ? (
                  <LineItemPlaceholder />
                ) : (
                  <LineItem data={item} />
                )}
              </SlideContainer>
            )}
          />
        </CarouselContainer>
      )}
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'container',
})``

const CarouselContainer = styled.div``

const SlideContainer = styled.div.attrs({
  className: 'p-0',
})`
  min-width: 27rem;
`
